<template>
  <b-field>
    <p class="control">
      <b-dropdown>
        <button type="button" class="button" slot="trigger">
          <span>{{$tc('dropdown.filters')}}</span>
          <b-icon icon="menu-down"></b-icon>
        </button>

          <div class="dropdown-item" style="width: 300px">
          <b-field label="Payment">
            <b-select
            v-model="payment">
              <option value="aiap">Appstore</option>
              <option value="playstore">PlayStore</option>
              <option value="qpay">Qpay</option>
            </b-select>
          </b-field>

          <b-field label="Type">
            <b-select
              v-model="type">
              <option value="app">App</option>
              <option value="web">Web</option>
              <option value="gift">Gift</option>
            </b-select>
          </b-field>

          <b-field label="Select a date">
            <b-datepicker placeholder="Click to select..." v-model="dateRange" range></b-datepicker>
          </b-field>
        </div>
      </b-dropdown>
    </p>

    <b-input
      :placeholder="$tc('dater.range')"
      type="search"
      icon="magnify"
      icon-clickable
      v-model="filters.search"
      expanded
    ></b-input>

    <div class="control">
      <button type="reset" class="button" @click="reset">
        <b-icon icon="close"></b-icon>
        <span>{{$tc('reset')}}</span>
      </button>
    </div>
  </b-field>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      dateRange: null,
      payment:null,
      type:null,
      filters: this.default()
    };
  },

  watch: {
    dateRange(value) {
      this.filters.starts_at = moment(value[0]).format("YYYY-MM-DD");
      this.filters.ends_at = moment(value[1]).format("YYYY-MM-DD");
    },

    payment(value) {
      this.filters.payment = value
    },

    type(value) {
      this.filters.type = value
    },

    filters: {
      deep: true,
      handler() {
        this.$emit("input", this.filters);
      }
    }
  },

  methods: {
    reset() {
      this.filters = this.default();
      this.dateRange = null;
    },

    default() {
      return {
        payment: null,
        type: null,
        search: null,
        starts_at: null,
        ends_at: null
      };
    }
  }
};
</script>
